var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDaIdea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 20,
    viewBox: "0 0 26.68 8.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #77a395;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.05,0V8.42H0V0H2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.02,.53c.66,.35,1.18,.85,1.54,1.48,.36,.64,.55,1.37,.55,2.2s-.18,1.56-.55,2.2c-.36,.64-.88,1.14-1.55,1.49-.67,.35-1.44,.53-2.32,.53H3.54V0h3.16c.89,0,1.66,.18,2.33,.53Zm-.65,5.48c.43-.42,.65-1.02,.65-1.8s-.22-1.38-.65-1.81c-.43-.43-1.04-.65-1.81-.65h-.97V6.65h.97c.78,0,1.38-.21,1.81-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.32,1.64v1.7h2.75v1.58h-2.75v1.85h3.11v1.64h-5.16V0h5.16V1.64h-3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,6.94h-3.14l-.5,1.49h-2.15L21.25,0h2.38l3.05,8.42h-2.17l-.5-1.49Zm-.53-1.58l-1.04-3.08-1.03,3.08h2.08Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaIdea);
export default __webpack_public_path__ + "static/media/da_idea.e3adc25301ff9e0d72cbf4971f21bb14.svg";
export { ForwardRef as ReactComponent };